import EnumClass, { build } from '../EnumClass';
import data, { IssueStatusId, IssueStatusData } from './data';
import * as Translations from './translations';

export class IssueStatus extends EnumClass<IssueStatusId, IssueStatusData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: ISSUE_STATUSES,
  getById: getIssueStatusById,
  marshaller: IssueStatusMarshaller,
  codec: IssueStatusCodec,
} = build<IssueStatusId, IssueStatusData, IssueStatus>('IssueStatusEnum', data, IssueStatus);
